import { Route, Redirect } from 'react-router-dom'
// @common
import { RouteComponentType } from 'modules/auth/types'
import Helper from 'utils/Helper.class'
import { userTypes } from 'modules/user'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'

const PrivateRoute = (props: RouteComponentType) => {
  const { data } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  const { isAuth, allowedUserTypes = [], ...routeProps } = props

  const userType = data?.user?.membership?.isMember ? userTypes.MEMBER : ''
  const isAllovedRole =
    !allowedUserTypes.length || allowedUserTypes.includes(userType)

  return isAuth ? (
    isAllovedRole ? (
      <Route {...routeProps} />
    ) : (
      <Redirect
        to={{ pathname: Helper.getPathFromRouteKey('MYATD_DASHBOARD') }}
      />
    )
  ) : (
    <Redirect to={{ pathname: Helper.getPathFromRouteKey('home') }} />
  )
}

export default PrivateRoute
